// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"acbb521d","977":"5995ce99"}[chunkId] + ".chunk.js";
};